import React, { FC, useEffect } from "react";
import logo from "./logo.svg";
import "./App.css";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  Navigate,
  Outlet,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import VisuallLoading from "./componsnts/common/visuallLoading/visuallLoading";
import Home from "./pages/Home/home";
import Login from "./pages/login/login";
import Buyer from "./pages/buyer/buyer";
import Seller from "./pages/seller/seller";
import HeaderLayout from "./componsnts/layouts/header/header";
import AboutUs from "./pages/about-us/about-us";
import FAQ from "./pages/faq/faq";
import Trading from "./pages/trading/trading";
import Verify from "./pages/login/verify/verify";
import PasswordChanging from "./pages/password-changing/password-changing";
import KnowHow from "./pages/know-how/know-how";
import PublicInfomation from "./pages/public-information/public-info";

const App: FC<any> = () => {
  const routers = createBrowserRouter([
    {
      path: "/",
      element: <HeaderLayout />,
      children: [
        {
          path: "",
          element: <Navigate to="home" />,
        },
        {
          path: "home",
          element: <Home></Home>,
        },
        {
          path: "login",
          element: <Login />,
        },
        {
          path: "login/verify",
          element: <Verify></Verify>,
        },
        {
          path: "buyer",
          element: <Buyer></Buyer>,
        },
        {
          path: "seller",
          element: <Seller></Seller>,
        },
        {
          path: "about-us",
          element: <AboutUs></AboutUs>,
        },
        {
          path: "faq",
          element: <FAQ></FAQ>,
        },
        {
          path: "trading",
          element: <Trading></Trading>,
        },
        {
          path: "password-changing",
          element: <PasswordChanging></PasswordChanging>,
        },
        {
          path: "know-how",
          element: <KnowHow></KnowHow>,
        },
        {
          path: "public-information",
          element: <PublicInfomation></PublicInfomation>,
        },
      ],
    },


  ]);

  // 初始化動畫
  useEffect(() => {
    AOS.init();
  }, []);



  return (
    <RouterProvider
      router={routers}
      fallbackElement={<VisuallLoading />}
      future={{ v7_startTransition: true }}
    />
  );
};

export default App;
